module.exports = __webpack_public_path__ + "static/media/Nutrients_1_orange.7d945897.png";